<div class="fixed top-4 right-4 z-[9999] flex flex-col gap-3 w-full max-w-sm pointer-events-none">
  @for (toast of toasts(); track trackById($index, toast)) {
  <div
    class="pointer-events-auto flex items-start gap-3 rounded-xl px-4 py-3 shadow-lg border backdrop-blur-sm transition-all duration-300"
    [class]="toast.type === 'success' ? 'bg-success/10 border-success/30 text-content' :
               toast.type === 'info'    ? 'bg-primary/10 border-primary/30 text-content' :
                                          'bg-danger/10 border-danger/30 text-content'"
    role="alert"
    [attr.aria-live]="toast.type === 'error' ? 'assertive' : 'polite'"
  >
    <lib-icon
      [icon]="iconFor(toast.type)"
      class="w-5 h-5 flex-shrink-0 mt-0.5"
      [class]="toast.type === 'success' ? 'text-success' :
                 toast.type === 'info'    ? 'text-primary' :
                                            'text-danger'"
    />
    <p class="flex-1 text-sm font-medium leading-snug">{{ toast.message }}</p>
    <button
      type="button"
      (click)="dismiss(toast.id)"
      class="flex-shrink-0 rounded-md p-0.5 text-content-muted hover:text-content hover:bg-surface-overlay transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-primary"
      aria-label="Close"
    >
      <lib-icon icon="x-mark" class="w-4 h-4" />
    </button>
  </div>
  }
</div>
